export default (element, container) => {
  const { bottom, height, top } = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  return top <= containerRect.top
    ? containerRect.top - top + height <= height
    : bottom - containerRect.bottom + height <= height;
};
